import { Link } from 'react-router-dom';
import Search from '@material-ui/icons/Search';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeparturesIcon from '@material-ui/icons/FlightTakeoff';
import FlightsIcon from '@material-ui/icons/Flight';
import LoginIcon from '@material-ui/icons/ConfirmationNumber';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useEffect } from 'react';

export const iconFinder = (label, isOpen, isMobile) => {
  if (isMobile && isOpen) {
    return <div></div>
  }
  switch (label) {
    case "Login":
      return <LoginIcon />
    case "Flights":
      return <FlightsIcon />
    case "DCS":
      return <DeparturesIcon />
    case "Inventory-Updater":
      return <EventSeatIcon />
    case "Bulk":
      return <InsertInvitationIcon />
    case "Compare":
      return <InsertInvitationIcon />
    case "Admin":
      return <SupervisorAccountIcon />
    case "Pax-Search":
      return <Search />
    case "Profile":
      return <AccountCircleIcon />
    default:
      return
  }
}

export const MobileButton = (props) => {
  const isOpen = props.isOpen
  const label = props.label
  const isMobile = props.isMobile
  let displayLabel = label === 'Inventory-Updater' ? 'Inventory' : label

  if (isOpen) {
    return (
      <ListItem style={{paddingTop: '6px', paddingLeft: '4px'}}>
        <ListItemText >{displayLabel}</ListItemText>
      </ListItem>
    )
  }
  else {
    return (
      <ListItem style={{paddingTop: '6px', paddingLeft: '4px'}}>
        <ListItemIcon>{iconFinder(label, isOpen, isMobile)}</ListItemIcon> :
      </ListItem>
    )
  }
}

export const RegularButton = (props) => {
  const isOpen = props.isOpen
  const label = props.label
  const isMobile = props.isMobile

  if (isOpen) {
    return (
      <ListItem button>
        <ListItemIcon>{iconFinder(label, isOpen, isMobile)}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </ListItem>
    )
  }
  else {
    return (
      <ListItem button>
        <ListItemIcon>{iconFinder(label, isOpen, isMobile)}</ListItemIcon>
      </ListItem>
    )
  }
}

// SECTION navBar
export const NavListItem = (props) => {
  console.log({props});
  const isMobile = props.isMobile
  const classes = props.classes
  const isOpen = props.isOpen


  

  
   

  if (props.hasAccess || props.label === 'Login') {
      return (
      <Link to={`/${props.label.toLowerCase()}`} className={classes.navLink} onClick={()=>props.handleDrawer()} >
          {isMobile ?
          <MobileButton isOpen={isOpen} label={props.label} isMobile={isMobile} /> :
          <RegularButton isOpen={isOpen} label={props.label} isMobile={isMobile}/>
          }
      </Link>
    )
  }
  else {
    return <div></div>
  }
}